const addressKeys = [
    'country_code',
    'first_name',
    'last_name',
    'address_1',
    'address_2',
    'addition',
    'postal_code',
    'city',
    'phone',
]

const getShippingData = (cartAddress?: any) => {
    return addressKeys.reduce(
        (acc, key) => ({
            ...acc,
            // @ts-ignore
            [key]: cartAddress?.[key],
        }),
        {},
    )
}

export default getShippingData
